import { useQuery } from '@tanstack/react-query'
import { getDemoCompany } from '../api/demo-customer.api'

type UseViewDemoCompanyProps = {
  id: string
}

/**
 * Reads a single demo company from the demo API.
 *
 * Shares the ['getCustomer', id] query key with useViewCustomer because the
 * payload is identical — this just goes through the demo endpoint, which
 * rejects non-demo ids.
 */
export default function useViewDemoCompany({ id }: UseViewDemoCompanyProps) {
  const { isPending, error, data } = useQuery({
    queryKey: ['getCustomer', id],
    queryFn: () => getDemoCompany(id),
    staleTime: Infinity,
  })

  return { isLoading: isPending, error, data }
}
